import { render, staticRenderFns } from "./IconSpinner.vue?vue&type=template&id=30e56eea&"
var script = {}
import style0 from "./IconSpinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports